import { render, staticRenderFns } from "./AddQuoteClientView.vue?vue&type=template&id=ca58acd8&scoped=true&lang=pug"
import script from "./AddQuoteClientView.vue?vue&type=script&lang=js"
export * from "./AddQuoteClientView.vue?vue&type=script&lang=js"
import style0 from "./AddQuoteClientView.vue?vue&type=style&index=0&id=ca58acd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca58acd8",
  null
  
)

export default component.exports